import { trpc } from "../../../main/components/trpc.ts";
import PatientsStateManager from "../PatientsStateManager";

const ActivePatients = () => {
  const activePatients = trpc.patient.getPatientsEnCours.useQuery().data || [];

  return <PatientsStateManager patients={activePatients} sortType="active" />;
};

export default ActivePatients;
